export default __webpack_public_path__ + "static/media/manuable_fulfillment.7c8db3ab.png";